import { render, staticRenderFns } from "./BbeeEsquemaIncentivosEi.vue?vue&type=template&id=452b1705"
import script from "./BbeeEsquemaIncentivosEi.vue?vue&type=script&lang=js"
export * from "./BbeeEsquemaIncentivosEi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports